import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAppSelector } from 'src/redux/store/store';

import { ROUTE_MENU } from '../../constants';

interface PrivateRouteProps {
  component: React.ComponentType<any>;
}

const RequiresLocation: React.FunctionComponent<PrivateRouteProps> = ({
  component: Component,
}) => {
  const locationInfo = useAppSelector((state) => state.location);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const category_id = query.get('category_id');

  return !locationInfo?.selectedStore?.id ? (
    <Navigate
      to={ROUTE_MENU}
      replace={true}
      state={{
        referrer: location.pathname,
        category_id: category_id,
      }}
    />
  ) : (
    <Component />
  );
};

export default RequiresLocation;
